module.exports = __webpack_public_path__ + "static/media/getFetch.5741eb84.cjs";